import styled from "@emotion/styled";

export const FlexColContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FlexRowContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const SeparatorLine = styled.div`
  height: 1rem;
  margin: ${({ theme }) => theme.spacing(0.5)} 0;
  width: 1px;
  border: 1px solid ${({ theme }) => theme.colours.accent.light._60};
  opacity: 1;
`;

export const SeparatorLineVertical = styled.div`
  width: 1px;
  height: 12px;
  margin: 2px 4px;
  border: solid 1px ${({ theme }) => theme.colours.accent.light._50};
`;

export const SeparatorLineHorizontal = styled.div`
  flex-grow: 1;
  height: 1px;
  margin: 11px 0 12px 16px;
  border: solid 1px ${({ theme }) => theme.colours.uIGrey.light._20};
`;
